import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    // Layout: Introduction_title_with_goals
    introductionTitleWithGoals: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        padding: '0 30px',
        width: '100%',
        height: '90%',
    },
    introductionTitle: {
        fontSize: '35px',
        fontWeight: 'bold',
        color: '#ED6628',
        marginBottom: theme.spacing(2),
    },
    introductionContent: {
        fontSize: '18px',
        color: '#474747',
        maxWidth: '800px',
    },

    // Layout: content_3_points_with_no_image
    content3PointsNoImage: {
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '90%',
        height: '90%',
        borderRadius: '25px',
        padding: theme.spacing(4),
    },
    content3PointsTitle: {
        fontSize: '35px',
        fontWeight: 'bold',
        color: '#ED6628',
        marginBottom: theme.spacing(3),
    },
    content3PointsList: {
        listStyleType: 'disc',
        paddingLeft: '20px',
        textAlign: 'left',
    },
    content3PointsListItem: {
        fontSize: '18px',
        color: '#474747',
        marginBottom: theme.spacing(2),
    },

    // Layout: content_3_points_with_1_image
    content3Points1Image: {
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '90%',
        height: '90%',
        borderRadius: '25px',
        padding: theme.spacing(4),
    },
    content3Points1ImageTitle: {
        fontSize: '35px',
        fontWeight: 'bold',
        color: '#ED6628',
        marginBottom: theme.spacing(3),
    },
    content3Points1ImageContent: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    content3Points1ImageList: {
        width: '60%',
        listStyleType: 'disc',
        paddingLeft: '20px',
        textAlign: 'left',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    content3Points1ImageListItem: {
        fontSize: '18px',
        color: '#474747',
        marginBottom: theme.spacing(2),
    },
    content3Points1ImageImage: {
        width: '35%',
        borderRadius: '20px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginTop: theme.spacing(3),
        },
    },

    // Layout: content_4_points_with_no_image
    content4PointsNoImage: {
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '90%',
        height: '90%',
        borderRadius: '25px',
        padding: theme.spacing(4),
    },
    content4PointsTitle: {
        fontSize: '35px',
        fontWeight: 'bold',
        color: '#ED6628',
        marginBottom: theme.spacing(3),
    },
    content4PointsList: {
        listStyleType: 'disc',
        paddingLeft: '20px',
        textAlign: 'left',
    },
    content4PointsListItem: {
        fontSize: '18px',
        color: '#474747',
        marginBottom: theme.spacing(2),
    },

    // Layout: content_single_point_with_1_image
    contentSinglePoint1Image: {
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '90%',
        height: '90%',
        borderRadius: '25px',
        padding: theme.spacing(4),
    },
    contentSinglePointTitle: {
        fontSize: '35px',
        fontWeight: 'bold',
        color: '#ED6628',
        marginBottom: theme.spacing(3),
    },
    contentSinglePointContent: {
        fontSize: '18px',
        color: '#474747',
        textAlign: 'center',
        maxWidth: '800px',
    },
    contentSinglePointImage: {
        width: '50%',
        borderRadius: '20px',
        marginTop: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },

    // Layout: content_description_with_no_image
    contentDescriptionNoImage: {
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '90%',
        height: '90%',
        borderRadius: '25px',
        padding: theme.spacing(4),
    },
    contentDescriptionTitle: {
        fontSize: '35px',
        fontWeight: 'bold',
        color: '#ED6628',
        marginBottom: theme.spacing(3),
    },
    contentDescriptionContent: {
        fontSize: '18px',
        color: '#474747',
        textAlign: 'center',
        maxWidth: '800px',
    },

    // Layout: final_summary
    finalSummary: {
        backgroundColor: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '90%',
        height: '90%',
        borderRadius: '25px',
        padding: theme.spacing(4),
    },
    finalSummaryTitle: {
        fontSize: '35px',
        fontWeight: 'bold',
        color: '#ED6628',
        marginBottom: theme.spacing(3),
    },
    finalSummaryContent: {
        fontSize: '18px',
        color: '#474747',
        textAlign: 'center',
        maxWidth: '800px',
    },
}));

export default useStyles;